import { BaseApiExternalV1Resource } from '@/modules/core/app/resources/BaseApiExternalV1Resource';
import { LightDiagnosticCalculatePlanForm } from '@/modules/lightdiagnostic/models/LightDiagnosticCalculatePlanForm';
import { Route } from '/@/modules/core/app/constants/api.constants';

export class LightDiagnosticExternalResource extends BaseApiExternalV1Resource {
  calculateBillingPlan(params: Params = {}): Promise<LightDiagnosticCalculatePlanForm> {
    return this.postData(Route.LIGHTDIAGNOSTIC_CALCULATEBILLINGPLAN, params);
  }
}

export default new LightDiagnosticExternalResource();
